import { createSlice } from '@reduxjs/toolkit';
import Constants from "../common/Constants";

const initialState = {
    message: '',
    isShow: false,
    type: Constants.NOTIFICATION_TYPE.INFO,
    duration: Constants.DEFAULT_NOTIFICATION_DURATION
}
export const NotificationSlice = createSlice({
    name: 'NotificationSlice',
    initialState: initialState,
    reducers: {
        showNotification: (state, {payload}) => {
            state.message =  payload.message
            state.isShow = true,
            state.duration = payload.duration,
            state.type = payload.type
        },
        hideNotification: state => {
            state.message =  ''
            state.isShow = false,
            state.type = Constants.NOTIFICATION_TYPE.INFO,
            state.duration = Constants.DEFAULT_NOTIFICATION_DURATION
        }
    }

});

export const {
    showNotification,
    hideNotification
} = NotificationSlice.actions
export const notificationSelector = state => state.NotificationSlice
export default NotificationSlice.reducer;


// WEBPACK FOOTER //
// ./src/app/slices/NotificationSlice.js